(() => {
  if (customElements.get('product-faqs')) return;

  class ProductFaqs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.faqReady === 'true') return;
      this.dataset.faqReady = 'true';
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = (event) => {
      const toggle = event.target.closest('[data-faq-toggle]');
      if (!toggle || !this.contains(toggle)) return;

      if (toggle.hasAttribute('data-faq-group-toggle')) {
        const group = toggle.closest('.product-faqs__group');
        const panel = group?.querySelector('[data-faq-group-panel]');
        if (!group || !panel) return;

        const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
        if (!willOpen) this.closeAnswers(group);
        this.setOpen(group, toggle, panel, willOpen);
        return;
      }

      const item = toggle.closest('.product-faqs__item');
      const panel = item?.querySelector('[data-faq-answer-panel]');
      if (!item || !panel) return;

      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      const group = item.closest('.product-faqs__group');
      group?.querySelectorAll('.product-faqs__item.is-open').forEach((openItem) => {
        if (openItem === item) return;
        const openToggle = openItem.querySelector('[data-faq-toggle]');
        const openPanel = openItem.querySelector('[data-faq-answer-panel]');
        if (openToggle && openPanel) this.setOpen(openItem, openToggle, openPanel, false);
      });
      this.setOpen(item, toggle, panel, willOpen);
    };

    setOpen(container, toggle, panel, isOpen) {
      container.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', String(isOpen));
      panel.setAttribute('aria-hidden', String(!isOpen));
      if (isOpen) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
    }

    closeAnswers(group) {
      group.querySelectorAll('.product-faqs__item.is-open').forEach((item) => {
        const toggle = item.querySelector('[data-faq-toggle]');
        const panel = item.querySelector('[data-faq-answer-panel]');
        if (toggle && panel) this.setOpen(item, toggle, panel, false);
      });
    }
  }

  customElements.define('product-faqs', ProductFaqs);
})();
